import { SocialPublishAtField } from '@app/modules/social-export/components/inputs/SocialPublishAtField';
import {
  getBaseExportSchema,
  MessageFormatter,
} from '@app/modules/social-export/components/validation/base-export-schema';
import { BaseExportFormProps } from '@app/modules/social-export/hooks/useSocialExportFactory';
import { FormSection } from '@app/modules/social-export/screens/manage/platforms/FormSection';
import { zodResolver } from '@hookform/resolvers/zod';
import { socialExport } from '@mi-front/api-clients';
import { Grid } from '@mui/material';
import { useMemo } from 'react';
import { FormContainer, TextFieldElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { z } from 'zod';

type TwitterPublishFormProps = BaseExportFormProps<
  socialExport.TwitterPublishDto,
  socialExport.TwitterSettingsDto
>;

const requiredMsg = { id: 'common.required', defaultMessage: 'Requerido' };

function getTwitterPublishValidationSchema(t: MessageFormatter) {
  return getBaseExportSchema(t).extend({
    content: z.string().trim().min(1, t(requiredMsg)),
  });
}

type TwitterPublishValues = z.infer<ReturnType<typeof getTwitterPublishValidationSchema>>;

export function TwitterPublishForm({ fragment, onUpload, actions }: TwitterPublishFormProps) {
  const { $t } = useIntl();
  const schema = useMemo(() => getTwitterPublishValidationSchema((msg) => $t(msg)), [$t]);
  const initialValues: TwitterPublishValues = {
    content: fragment.description ?? '',
    publishAt: null,
  };

  const beforeSubmit = (data: TwitterPublishValues): socialExport.TwitterPublishDto => ({
    description: data.content,
    publishAt: data.publishAt || undefined,
  });

  return (
    <FormContainer
      values={initialValues}
      resolver={zodResolver(schema)}
      onSuccess={async (formData) => {
        await onUpload(beforeSubmit(formData));
      }}
    >
      <FormSection
        title={$t({
          id: 'socialExport.form.content',
          defaultMessage: 'Contenido',
        })}
      >
        <TextFieldElement
          name="content"
          label={$t({
            id: 'socialExport.form.content',
            defaultMessage: 'Contenido',
          })}
          required
          fullWidth
          multiline
          rows={3}
        />
      </FormSection>
      <FormSection
        title={$t({
          id: 'socialExport.form.scheduling',
          defaultMessage: 'Programación',
        })}
      >
        <Grid container>
          <Grid item md={12}>
            <SocialPublishAtField />
          </Grid>
        </Grid>
      </FormSection>
      {actions}
    </FormContainer>
  );
}
